<template>
  <div class="c-spotify">
    <iframe
      :src="`https://open.spotify.com/embed/track/${id}`"
      width="100%"
      height="80"
      frameborder="0"
      allowtransparency="true"
      allow="encrypted-media"
    ></iframe>
  </div>
</template>

<script>
export default {
  props: ["id"],
};
</script>
